module.exports = __webpack_public_path__ + "img/gallery-post-dark.50a6e163.jpg";